import RequestState from '../../types/RequestState';
import { consoleErrorUnlessFiltered } from '../../util/sentryFilters';

const useShippingDetails = ({ activeProductId }) => {
  const fetchShippingDetails = ({ product }) => {
    const activeId = activeProductId || product.id;

    if (
      !product.shippingStates.get(activeId) ||
      product.shippingStates.get(activeId) === RequestState.NONE
    ) {
      product
        .loadShippingDetails({
          activeId,
        })
        .catch((e) => {
          consoleErrorUnlessFiltered(e);
        });
    }
  };

  return [fetchShippingDetails];
};

export default useShippingDetails;
